import { DefaultConstraints, LowConstraints } from "@/tools/config.js";
import * as mediasoup from "mediasoup-client";

export default class Donator {
  constructor(data, stream) {
    this.g = data;
    this.stream = stream;

    this.stream.getVideoTracks()[0].onended = () => {
      this.g.$root.$alert("Notice", "Your room has been closed.");

      this.g.$socket.emit("close donator public", this.roomID, this.g.user.id);

      this.g.sockets.unsubscribe("update users");
      this.g.sockets.unsubscribe("reconnect");

      this.g.closeHost();
    };
    this.stream.getVideoTracks()[0].applyConstraints(DefaultConstraints.video);
    this.sockets();
  }
  init() {
    let user = this.g.user;
    let roomName = this.g.publicRoomName;
    let roomDescription = this.g.publicRoomDescription;
    let coverURL = this.g.coverURL;
    let category = this.g.categorySelector;
    let unlisted = this.g.unlistRoom;
    let device = new mediasoup.Device();

    let object = {
      user: user,
      roomName: roomName,
      roomDescription: roomDescription,
      coverURL: coverURL,
      category: category,
      unlisted: unlisted
    };

    this.g.$socket.emit("host donator public", object, async output => {
      if (output == "invalid token") this.g.$root.logout();
      if (output == "invalid input") {
        this.stream.getTracks().forEach(track => track.stop());
        this.g.$root.$alert("Error", "One or more inputs are invalid.", {
          color: "red"
        });
      } else if (output.return == "success") {
        this.roomID = output.roomID;
        await device.load({
          routerRtpCapabilities: output.rtpCapabilities
        });

        this.g.publicRoom = false;

        const transport = device.createSendTransport(output.params);

        transport.on("connect", async ({ dtlsParameters }, callback) => {
          this.g.$socket.emit(
            "connect producer transport public",
            {
              roomID: output.roomID,
              dtlsParameters: dtlsParameters
            },
            function() {
              callback();
            }
          );
        });

        transport.on("produce", async ({ kind, rtpParameters }, callback) => {
          if (kind == "video") {
            this.g.$socket.emit(
              "create video producer public",
              {
                roomID: output.roomID,
                transportId: transport.id,
                kind,
                rtpParameters
              },
              ({ id }) => {
                callback({
                  id
                });
              }
            );
          } else if (kind == "audio") {
            this.g.$socket.emit(
              "create audio producer public",
              {
                roomID: output.roomID,
                transportId: transport.id,
                kind,
                rtpParameters
              },
              ({ id }) => {
                callback({
                  id
                });
              }
            );
          }
        });

        let videoTrack = this.stream.getVideoTracks()[0];
        let audioTrack = this.stream.getAudioTracks()[0];

        transport.produce({
          track: videoTrack
        });
        if (audioTrack) {
          transport.produce({
            track: audioTrack
          });
        }

        this.g.setStream(this.stream);
        this.g.privateRoom = false;
        this.roomID = output.roomID;
        this.g.roomID = output.roomID;
        this.g.roomName = roomName;
        this.g.roomDescription = roomDescription;
        this.g.isPublic = true;
        this.g.roomCategory = object.category;
        this.g.roomCoverURL = object.coverURL;
        this.g.roomIsListed = !object.unlisted;
      }
    });
  }
  changeQuality(quality) {
    if (quality == "low") {
      this.stream.getVideoTracks()[0].applyConstraints(LowConstraints.video);
    } else if (quality == "high") {
      this.stream
        .getVideoTracks()[0]
        .applyConstraints(DefaultConstraints.video);
    }
  }
  sockets() {
    this.g.sockets.subscribe("update users", users => {
      this.g.users = users;
    });
    this.g.sockets.subscribe("reconnect", () => {
      if (this.g.streaming)
        this.g.$socket.emit("reconnection", {
          user: this.g.user,
          roomID: this.roomID
        });
    });
  }

  close(callback) {
    this.stream.getVideoTracks().forEach(track => track.stop());

    this.g.$socket.emit("close donator public", this.roomID, this.g.user.id);

    this.g.sockets.unsubscribe("update users");
    this.g.sockets.unsubscribe("reconnect");

    this.g.closeHost();

    callback();
  }
}
